/** ---------------------------------------------------------------------------------------
 * --  LICENSE AGREEMENT -- *
 This software is licensed under the following terms:

 * -- GRANT OF LICENSE | RESTRICTIONS -- *
 Subject to the terms and conditions of this license, the copyright holders
 hereby grant you a non-exclusive, non-transferable, revocable license to use,
 copy, modify, and distribute the software.
 You are expressly prohibited from selling or commercially exploiting the software.
 Unauthorized use, reproduction, or distribution of the software, or any part
 thereof, is strictly prohibited.

 * -- AUTHORIZED USERS | INTELLECTUAL PROPERTY -- *
 This license is granted only to the individual or entity to whom the software is
 directly distributed by the copyright holders. Any use by other individuals or
 entities is unauthorized and in violation of this license. The software is
 protected by copyright and other intellectual property laws.
 The copyright holders retain all rights, title, and interest in the software.

 * -- GOVERNING LAW -- *
 This license is governed by and construed in accordance with the laws of Romania.
 Any legal action or proceeding related to this license shall be brought exclusively
 in the courts of Romania.

 [Weddify x Diaphan Stationery] © [2024] All rights reserved.
 -------------------------------------------------------------------------------------- **/

import React from 'react';
import AppButton from "../button/AppButton";
import {IoStarSharp} from "react-icons/io5";
import AppStatic from "../../utils/AppStatic";
import {appReviews} from '../../utils/AppConfig';
import Link from "next/link";
import Image from "next/image";
import logoGoogle from '@/assets/images/utils/logo-google.webp';

const AppReviews = () => {

    const reviews = [
        {
            name: 'Alice C.',
            review: 'Mulțumesc din suflet pentru profesionalism, rabdare si toata dedicarea pe parcursul colaborarii. Chiar daca am terminat cu materialele pentru nunta, vom reveni cu drag la voi cu orice alta ocazie si ne vom asigura ca si prietenii si colegii nostri stiu ce treaba groazava faceti!',
            where: 'google',
            stars: 5
        },
        {
            name: 'Alexa R.',
            review: 'Recomand Diaphan Stationery oricui are nevoie de papetarie pentru un eveniment sau alte ocazii. Am colaborat cu ocazia botezului fetitei noastre, atat pentru invitatii (care au iesit absolut superbe), cat si pentru papetaria de eveniment (meniuri, name tags, inclusiv etichete pentru micile atentii pregatite pentru invitati). Multumim pentru tot, va recomandam cu drag!',
            where: 'google',
            stars: 5
        },
        {
            name: 'Catalina M.',
            review: 'Diaphan a fost secretul nostru pentru o nunta de poveste, combinatia perfecta de bun gust si profesionalism! Reactia noastra a fost "WOW!" si o recomandam din tot sufletul! 🤍',
            where: 'google',
            stars: 5
        },
        {
            name: 'EEA C.',
            review: 'Am colaborat pentru papetaria legata de nunta mea (meniuri, numere de mese, coduri QR) si am fost mai mult decat multumita! Sunt foarte atenti la detalii si comunicarea a fost esentiala, totul a iesit exact cum mi-am dorit! Ii recomand cu incredere si cu siguranta voi mai apela la serviciile lor in viitor 🫶🏻❤️ sunt cu adevarat niste profesionisti!!',
            where: 'google',
            stars: 5
        },
        {
            name: 'Andreea D.',
            review: 'Am avut o colaborare excelenta iar rezultatul a iesit minunat! Toti ne au felicitat si ne au laudat invitatiile ! Multumim!',
            where: 'google',
            stars: 5
        },
        {
            name: 'Nicoleta-Teodora M.',
            review: 'Colaborare excelentă și produse de foarte bună calitate. Recomand cu drag!',
            where: 'google',
            stars: 5
        },
    ];

    return (
        <div>
            <h3 className="text-4xl font-bold md:text-6xl mb-2">{AppStatic.appReviewsHeading.ro.translation}</h3>
            <p className="mb-8 font-thin tracking-wider">{AppStatic.appReviewsSubHeading.ro.translation}</p>
            <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-4 gap-6">
                {reviews.map((review, index) => (
                    <Link href={appReviews} key={index} target="_blank"
                          className="app-feature rounded-3xl pt-8 pb-8 cursor-pointer hover:scale-105 transition-transform ease-in-out duration-300">
                        <div className="justify-center text-center font-bold flex items-center">
                            <p>{review.name}</p>
                            {review.where === 'google' && (
                                <Image className="w-10" src={logoGoogle} alt="Weddify by Diaphan" loading="lazy"/>
                            )}
                        </div>
                        <div className="flex justify-center gap-1 mb-4">
                            {[...Array(review.stars)].map((_star, index) => (
                                <IoStarSharp key={index} className="text-lg text-yellow-400"/>
                            ))}
                        </div>
                        <div className="text-center mx-[5px] text-mono-1000 font-thin my-auto text-xs px-4 mt-2">
                            {review.review}
                        </div>
                    </Link>
                ))}
                <div className="app-feature rounded-3xl pt-8 pb-8">
                    <div className="justify-center text-center font-bold flex items-center">
                        <p>{AppStatic.appReviewsCTAHeading.ro.translation}</p>
                    </div>
                    <div className="text-center mx-[5px] text-mono-1000 font-thin my-auto text-xs px-4 mt-2">
                        {AppStatic.appReviewsCTAText.ro.translation}
                    </div>
                    <div className="w-full flex text-center justify-center mx-auto mt-4!">
                        <AppButton data={{
                            action: "link",
                            link: appReviews,
                            extraClass: "bg-white! text-black! border-black!",
                            blank: true,
                            name: AppStatic.appReviewsCta.ro.translation,
                        }}/>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AppReviews;
